export const actions: IRowAction[] = [
  {
    id: 'rename',
    title: 'Rename',
    iconName: 'IconEdit',
    actionType: 'MODELS',
  },
  {
    id: 'copy',
    title: 'Copy',
    iconName: 'IconFiles', // Better for indicating file copying
    actionType: 'EDITOR',
  },
  {
    id: 'duplicate',
    title: 'Duplicate',
    iconName: 'IconStack', // Represents stacking/duplicating
    actionType: 'MODELS',
  },
  // {
  //   id: 'share',
  //   title: 'Share',
  //   iconName: 'IconShare', // Common sharing icon
  //   actionType: 'EDITOR',
  // },
  // {
  //   id: 'refreshThumb',
  //   title: 'Refresh Thumbnail',
  //   iconName: 'IconRefresh', // Standard refresh icon
  //   actionType: 'MODELS',
  // },
  // {
  //   id: 'showIntro',
  //   title: 'Show Intro',
  //   iconName: 'IconPlayerPlay', // Play button for intros/tutorials
  //   actionType: 'EDITOR',
  // },
  {
    id: 'delete',
    title: 'Delete',
    iconName: 'IconTrash',
    color: 'red',
    actionType: 'MODELS',
  },
];
